<template>
  <div class="bg-g3 px-4 py-1 flex justify-between items-center">
    <span>Bienvenue : {{ name }}</span>

    <span class="font-mono text-xs" v-if="RcSn">RC : {{RcSn}}</span>

    <button
      class="flex items-center text-g1"
      @click="logout"
      title="Se déconnecter"
    >
      <svg
        class="w-[15px] mr-2"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
        />
      </svg>
      Changer de compte
    </button>
  </div>

  <div class="p-4 pt-6 w-screen h-screen flex flex-col overflow-hidden">
    <div v-show="selectDevice == false">
      <DJI_RC_PLUS_Devices
        :devices="devices"
        :NewDevices="NewDevices"
        @response="(device) => (selectDevice = device)"
      />
    </div>

    <DJI_RC_PLUS_RC
      :selectDevice="selectDevice"
      @close="selectDevice = false"
      :sites="sites"
      v-if="selectDevice !== false"
    />
  </div>
</template>

<script>
import { ref } from "vue";

import API from "@/utils/API";

import DJI_RC_PLUS_Devices from "@/app/pilotlogin/DJI_RC_PLUS/template/Devices.vue";
import DJI_RC_PLUS_RC from "@/app/pilotlogin/DJI_RC_PLUS/template/Rc.vue";

export default {
  name: "PilotHome",
  components: {
    DJI_RC_PLUS_Devices,
    DJI_RC_PLUS_RC,
  },
  setup() {
    return {
      selectDevice: ref(false),
      name: ref("Pilot"),
      sites: ref([]),
      devices: ref([]),
      RcSn: ref(""),
      DroneSn: ref(""),
      platformGetRemoteControllerSN: ref(""),
      NewDevices: ref({
        dock: [],
        rc: [],
        drone: [],
        drone_externe: [],
        webcam: [],
        aeroscope: [],
        autre: [],
      }),
    };
  },

  async mounted() {
    await $root.user.updateInfo();
    this.name = $root.user.getData().con_firstname;
    this.sites = await API.get("site", {});

    this.update();
  },

  methods: {
    async update() {
      let devices = await API.get("device", {});

      let platformGetRemoteControllerSN = window?.djiBridge?.platformGetRemoteControllerSN();

      let platformGetAircraftSN = window?.djiBridge?.platformGetAircraftSN();
      let RcSn = JSON.parse(
        platformGetRemoteControllerSN == null
          ? "{}"
          : platformGetRemoteControllerSN
      );
      let DroneSn = JSON.parse(
        platformGetAircraftSN == null ? "{}" : platformGetRemoteControllerSN
      );

      if (RcSn?.code === 0) {
        this.RcSn = RcSn.data;
      }

      if (DroneSn?.code === 0) {
        this.DroneSn = DroneSn.data;
      }

      // Supprimer les devices qui on le dev_sn qui contient ENV.DELETED
      // et les devices qui sont dans le site garage
      // et les devices qui ne sont pas dans le site de l'utilisateur
      if (!this.$root.debug) {
        devices = devices.filter((device) => {
          return (
            !device.dev_sn.includes(ENV.DELETED) &&
            device.sit_name != ENV.DEVICE_SITE_GARAGE &&
            $root.user.accessSite(device.sit_id)
          );
        });
      }

      devices.sort((a, b) => {
        // Vérifie si det_id existe dans l'objet de référence en utilisant hasOwnProperty
        let aExists = this.$root.device_controller.hasOwnProperty(a.det_id)
          ? 1
          : -1;
        let bExists = this.$root.device_controller.hasOwnProperty(b.det_id)
          ? 1
          : -1;

        // Si les deux existent ou n'existent pas, on les trie par det_id
        if (aExists === bExists) {
          return a.det_id - b.det_id;
        }

        // Sinon, celui qui existe doit venir en premier
        return bExists - aExists;
      });

      devices.forEach((device) => {
        if (
          this.$root.global.site == undefined ||
          device.sit_id == this.$root?.global?.site?.sit_id
        ) {
          this.devices.push(device);

          if (this.$root.device_rc_type.hasOwnProperty(device.det_id)) {
            this.NewDevices.rc.push(device);
          }
          // DRONE
          else if (this.$root.device_drone.hasOwnProperty(device.det_id)) {
            this.NewDevices.drone.push(device);
            this.addOnDockOrRc(device, "drone");
          }

          if (this.RcSn == device.dev_sn) {
            this.selectDevice = device;
          }
        }
      });
    },

    logout() {
      $root.user.logout("rc");
      window.location.reload();
    },

    addOnDockOrRc(device, type) {
      this.searchOn(device, this.NewDevices.dock, type);
      this.searchOn(device, this.NewDevices.rc, type);
    },

    searchOn(device, array, type) {
      array.forEach((element) => {
        if (element?.dev_family?.drone_dev_id == device.dev_id) {
          element[type] = device;
        }
      });
    },
  },

  computed: {
    getUser() {
      return $root.user.getData();
    },
  },
};
</script>
